<template>
<div>
  <div class="section-title" v-if="onTabletUp && isPrimaryPlansView && !categorized">
    <h3
      >{{ $t('plans.title') }}
      <small
        >{{ $t('plans.subheading1') }}
        <br />
        {{ $t('plans.subheading2') }}
      </small>
    </h3>
  </div>

  <div :class="['plans', { 'screen-lg': onTabletUp && isPrimaryPlansView, categorized: categorized }, currentView.context]">
    <div class="plan-notice" v-if="!this.el.is.tabletUp && currentView.context === 'drawerModal'">
      <div class="icon-warning-shield">
        <svg svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64"><path fill="#ed7899" d="M54.29 11.57l-3.5-.23a27.89 27.89 0 01-15.63-6.08l-1.35-1.08a2.88 2.88 0 00-3.62 0l-1.35 1.08a27.89 27.89 0 01-15.64 6.08l-3.5.23A2.91 2.91 0 007 14.65l.67 9.22a39.35 39.35 0 0013.51 27l8.91 7.75a2.91 2.91 0 003.8 0l8.91-7.75a39.36 39.36 0 0013.51-27l.69-9.23a2.9 2.9 0 00-2.71-3.07z"/><path fill="#e0678f" d="M54.29 11.57l-3.5-.23a27.89 27.89 0 01-15.63-6.08l-1.35-1.08A2.89 2.89 0 0032 3.54v55.82a2.89 2.89 0 001.9-.71l8.91-7.75a39.36 39.36 0 0013.51-27l.68-9.26a2.9 2.9 0 00-2.71-3.07z"/><path fill="#f283a5" d="M44.5 24l1.24 2.26L48 27.5l-2.26 1.24L44.5 31l-1.24-2.26L41 27.5l2.26-1.24L44.5 24zm-22.08-4l.85 1.56 1.57.86-1.57.85-.85 1.57-.86-1.57-1.56-.85 1.56-.86.86-1.56zm-1.77 16l.58 1.06 1.07.59-1.07.58-.58 1.07-.58-1.07-1.07-.58 1.07-.59.58-1.06z"/><path fill="#faefde" d="M32.04 35a2 2 0 100 4 2 2 0 100-4zM31 32a1 1 0 102 0v-1l.92-14a1.93 1.93 0 00-.51-1.46 1.87 1.87 0 00-1.14-.56.7.7 0 00-.54 0 1.87 1.87 0 00-1.14.56 1.92 1.92 0 00-.51 1.44L31 31z"/><path fill="#8d6c9f" d="M22 43a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z"/><path fill="#8d6c9f" d="M55.08 9.87l-3.62-.24a28.87 28.87 0 01-16.19-6.29l-1.4-1.12a3 3 0 00-3.75 0l-1.4 1.12a28.85 28.85 0 01-16.18 6.29l-3.62.24A3 3 0 006.13 13l.69 11.6a40.74 40.74 0 0014 28l9.23 8a3 3 0 003.94 0l9.23-8a40.75 40.75 0 0014-28l.65-11.6a3 3 0 00-2.79-3.13zm.11 14.59A38.75 38.75 0 0148 44.37V44a1 1 0 00-2 0v2a1 1 0 00.24.63 39.47 39.47 0 01-4.36 4.45l-9.23 8a1 1 0 01-1.31 0l-9.23-8a39.46 39.46 0 01-4.36-4.45A1 1 0 0018 46v-2a1 1 0 00-2 0v.37a38.73 38.73 0 01-7.19-19.9l-.69-11.55a1 1 0 01.93-1.06l3.62-.24A30.85 30.85 0 0030 4.9l1.4-1.12a1 1 0 011.25 0L34 4.9a30.86 30.86 0 0017.3 6.72l3.62.24a1 1 0 01.93 1.06z"/><path fill="#8d6c9f" d="M44.21 12.66a29 29 0 01-8.49-4.08l-2.57-1.8a2 2 0 00-2.29 0l-2.57 1.8a29 29 0 01-14.7 5.18h-.65a1 1 0 00.07 2h.72a31 31 0 0015.72-5.54L32 8.42l2.57 1.8a30.94 30.94 0 009.08 4.36 1 1 0 10.56-1.92zM51 13.8h-.59c-.76-.05-1.53-.13-2.28-.24a1 1 0 10-.29 2c.8.12 1.62.21 2.44.26h.66a1 1 0 00.07-2z"/></svg>
      </div>
      <p>{{ $t('plans.headingNote') }}</p>
    </div>

    <span v-if="this.premium">
      <ScrollView :componentName="'FeaturedCard'" :cardType="'platelist'" :featured="true" :title="'Featured'" :platelist="this.platelist" />
      <ScrollView :componentName="'MealCard'" :cardType="'platelist'" :title="'All PlateLists'" :platelist="this.platelist" />
    </span>

    <div class="cards-wrapper" v-if="!this.premium">
      <div :class="['plan-notice', { 'screen-lg': this.el.is.tabletUp && isPrimaryPlansView }]" v-if="this.el.is.tabletUp">
        <div class="icon-warning-shield">
          <svg svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64"><path fill="#ed7899" d="M54.29 11.57l-3.5-.23a27.89 27.89 0 01-15.63-6.08l-1.35-1.08a2.88 2.88 0 00-3.62 0l-1.35 1.08a27.89 27.89 0 01-15.64 6.08l-3.5.23A2.91 2.91 0 007 14.65l.67 9.22a39.35 39.35 0 0013.51 27l8.91 7.75a2.91 2.91 0 003.8 0l8.91-7.75a39.36 39.36 0 0013.51-27l.69-9.23a2.9 2.9 0 00-2.71-3.07z"/><path fill="#e0678f" d="M54.29 11.57l-3.5-.23a27.89 27.89 0 01-15.63-6.08l-1.35-1.08A2.89 2.89 0 0032 3.54v55.82a2.89 2.89 0 001.9-.71l8.91-7.75a39.36 39.36 0 0013.51-27l.68-9.26a2.9 2.9 0 00-2.71-3.07z"/><path fill="#f283a5" d="M44.5 24l1.24 2.26L48 27.5l-2.26 1.24L44.5 31l-1.24-2.26L41 27.5l2.26-1.24L44.5 24zm-22.08-4l.85 1.56 1.57.86-1.57.85-.85 1.57-.86-1.57-1.56-.85 1.56-.86.86-1.56zm-1.77 16l.58 1.06 1.07.59-1.07.58-.58 1.07-.58-1.07-1.07-.58 1.07-.59.58-1.06z"/><path fill="#faefde" d="M32.04 35a2 2 0 100 4 2 2 0 100-4zM31 32a1 1 0 102 0v-1l.92-14a1.93 1.93 0 00-.51-1.46 1.87 1.87 0 00-1.14-.56.7.7 0 00-.54 0 1.87 1.87 0 00-1.14.56 1.92 1.92 0 00-.51 1.44L31 31z"/><path fill="#8d6c9f" d="M22 43a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm5 0a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z"/><path fill="#8d6c9f" d="M55.08 9.87l-3.62-.24a28.87 28.87 0 01-16.19-6.29l-1.4-1.12a3 3 0 00-3.75 0l-1.4 1.12a28.85 28.85 0 01-16.18 6.29l-3.62.24A3 3 0 006.13 13l.69 11.6a40.74 40.74 0 0014 28l9.23 8a3 3 0 003.94 0l9.23-8a40.75 40.75 0 0014-28l.65-11.6a3 3 0 00-2.79-3.13zm.11 14.59A38.75 38.75 0 0148 44.37V44a1 1 0 00-2 0v2a1 1 0 00.24.63 39.47 39.47 0 01-4.36 4.45l-9.23 8a1 1 0 01-1.31 0l-9.23-8a39.46 39.46 0 01-4.36-4.45A1 1 0 0018 46v-2a1 1 0 00-2 0v.37a38.73 38.73 0 01-7.19-19.9l-.69-11.55a1 1 0 01.93-1.06l3.62-.24A30.85 30.85 0 0030 4.9l1.4-1.12a1 1 0 011.25 0L34 4.9a30.86 30.86 0 0017.3 6.72l3.62.24a1 1 0 01.93 1.06z"/><path fill="#8d6c9f" d="M44.21 12.66a29 29 0 01-8.49-4.08l-2.57-1.8a2 2 0 00-2.29 0l-2.57 1.8a29 29 0 01-14.7 5.18h-.65a1 1 0 00.07 2h.72a31 31 0 0015.72-5.54L32 8.42l2.57 1.8a30.94 30.94 0 009.08 4.36 1 1 0 10.56-1.92zM51 13.8h-.59c-.76-.05-1.53-.13-2.28-.24a1 1 0 10-.29 2c.8.12 1.62.21 2.44.26h.66a1 1 0 00.07-2z"/></svg>
        </div>
        <p>{{ $t('plans.headingNote') }}</p>
      </div>
      <div class="plan-instructions" v-if="!onTabletUp && !isPrimaryPlansView">
        <h4 class="instructions-title">{{ $t('plans.lblSelectPlan') }}</h4>
        <p class="instructions-text">{{ $t('plans.subheading1') }}. {{ $t('plans.subheading2') }} </p>
      </div>

      <MealCard
        v-for="(plate, i) in plates"
        :key="i"
        :dish="plate"
        :cardType="'meal-full'"
        :onTabletUp="onTabletUp"
        :viewCtx="currentView.context"
        v-if="!categorized"
      />

      <div v-for="(plates, i) in categorizedPlates" :key="i" v-if="categorized && plates[0] !== 'none' && !onTabletUp && !isPrimaryPlansView">
        <ScrollView :componentName="'MealCard'" :cardType="'platelist'" :title="plates[0]" :platelist="plates[1]" />
      </div>

      <div
        class="categorized-plates"
        v-for="(plates, i) in categorizedPlates"
        :key="i"
        v-if="categorized && plates[0] !== 'none' && onTabletUp && isPrimaryPlansView"
      >
        <div class="section-title">
          <h3>{{ plates[0] }}</h3>
        </div>
        <div class="categorized-meal-card-container">
          <MealCard v-for="(plate, i) in plates[1]" :key="i" :dish="plate" :cardType="'meal-full'" :onTabletUp="onTabletUp" :viewCtx="currentView.context" />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import store from '@state/store';
import ScrollView from '../ScrollView/ScrollView';
import { breakpointsMixin } from 'breakpointsMixin';
import { gtmMixin } from 'gtmMixin';
import MealCard from '../MealCard/MealCard';
import appConfig from '@src/app.config.ES6';
import { platelistComputed, platelistMethods, primaryNavComputed, kitchenDrawerComputed } from '@state/helpers';

export default {
  mixins: [breakpointsMixin, gtmMixin],
  components: {
    MealCard,
    ScrollView,
  },
  props: {
    isEmbed: {
      type: Boolean,
    },
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {
      premium: false,
      appConfig,
    };
  },
  computed: {
    ...kitchenDrawerComputed,
    ...platelistComputed,
    ...primaryNavComputed,
    plates() {
      const sortedResponse = _.orderBy(
        _.cloneDeep(this.platelist),
        [
          (p) => {
            return p.position;
          },
        ],
        ['asc']
      );
      return sortedResponse;
    },
    categorized() {
      return appConfig.PLANS_CATEGORIZED;
    },
    categorizedPlates() {
      if (this.platelist && this.platelist.data) {
        return Object.entries(this.platelist.data);
      }
    },
    isPrimaryPlansView() {
      return this.primaryNavContent[this.activePrimaryNavIndex].component === 'Plans';
    },
    currentView() {
      return this.navContent[this.activeNavIndex];
    },
  },
  mounted() {
    this.gtmTrackEvent('pageView', { action: 'Visit Plans', label: 'Plans View' });
    this.getPlatelist({ categorized: this.categorized });
  },
  methods: {
    ...platelistMethods,
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.plan-notice {
  align-items: center;
  display: flex;
  padding: 0 1rem;

  .icon-warning-shield {
    display: flex;
    margin-right: 1rem;
    width: 12%;
  }

  p {
    color: lighten($color-lightGrey, 10);
    font-size: 1.4rem;
    line-height: 1.3;
    margin-bottom: 0;
  }

  &.screen-lg {
    margin: 0 0 1rem 1.5rem;
    padding: 0 1rem 0;
    width: 75%;

    .icon-warning-shield {
      width: 7%;
    }
  }
}

.plan-instructions {
  background-color: $color-background-plans-instructions;
  border: 1px solid $base-border-color;
  border-radius: $base-border-radius;
  margin: 0 0 1.5rem;
  padding: 1rem;

  .instructions-title {
    font-weight: bold;
  }

  .instructions-text {
    font-size: 1.4rem;
    line-height: 1.3;
    margin-bottom: 0;
  }
}

.section-title {
  border-top: 4px solid $color-navbar-bg;
  margin: 2rem 0 0 4rem;
  padding: 1rem 0;
  width: 75%;

  h3 {
    line-height: 1.3;

    small {
      display: block;
    }
  }
}

.plans {
  @extend %scrollable-drawer-content;

  .cards-wrapper {
    padding: 0 0.6rem 11rem;
  }

  &.screen-lg {
    display: flex;
    padding: 2rem 1rem 0;
    position: relative;

    .cards-wrapper {
      align-content: start;
      align-items: auto;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      width: 100%;
    }

    &.categorized {
      display: flex;
      padding: 2rem 1rem 0;
      position: relative;

      .categorized-plates {
        margin-bottom: 2rem;
        width: 100%;

        .section-title {
          margin-bottom: 1rem;
          margin-left: 3rem;
        }

        .categorized-meal-card-container {
          align-content: start;
          align-items: auto;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
        }
      }
    }
  }

  &.drawerModal {
    background-color: $color-kitchen-drawer-bg-open;
    border-bottom-left-radius: 2.5rem;
    border-bottom-right-radius: 2.5rem;
    box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.3);
  }
}
</style>
